import { zendeskAPI } from '../config/routes'
import { BackendCategory } from '../types/entities'
import { fetchData } from '../utils'
import { QueryKeys } from './queryKeys'

interface CategoriesResponse {
  categories: BackendCategory[]
}

const fetchCategories = async () => {
  const url = zendeskAPI.categories
  const json = await fetchData(url)

  if (json.error) {
    throw new Error(json.error)
  }

  return json
}

const categoriesQueryData = {
  key: QueryKeys.CATEGORIES,
  fetch: fetchCategories,
}

export { fetchCategories, categoriesQueryData }
export type { CategoriesResponse }
